<div class="app-nav-view">

  <div class="split1 top" [ngClass]="{'r-shadow':leftMenu || deviceInfo == 'ios' || deviceInfo == 'android'}">
    <app-event-nav></app-event-nav>
    <div class="left" [ngClass]="{'left-menu-width':leftMenu || deviceInfo == 'ios' || deviceInfo == 'android','d-none':paymentStatus}" [hidden]="router.url.includes('claim-tickets')">
      <app-event-menu></app-event-menu>
    </div>
    <ng-container>
      <div class="split right" [ngClass]="{'right-100' : router.url.includes('claim-tickets'),'right-menu-sec': leftMenu || deviceInfo == 'ios' || deviceInfo == 'android','mt-81':streamInfo?.event_logo}">
        <div class="p-20 pb-40" [ngClass]="{'pad-0':leftMenu || deviceInfo == 'ios' || deviceInfo == 'android'}">
          <router-outlet></router-outlet>
        </div>

        <div class="p-0" *ngIf="!leftMenu">
          <app-website-footer></app-website-footer>
        </div>

      </div>
    </ng-container>
  </div>
  <!-- <div class="split1 bottom">
        <app-website-footer></app-website-footer>
    </div>  -->
</div>